export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'browser' // browser,wechat
    }
  },
  data: function data() {
    return {
      visible: this.modelValue
    };
  },
  emits: ['update:modelValue'],
  computed: {},
  methods: {
    destroyElement: function destroyElement() {
      this.$el.removeEventListener('transitionend', this.destroyElement);
      this.$el.parentNode.removeChild(this.$el);
    },
    close: function close() {
      this.visible = false;
      this.$emit('update:modelValue', false);
      this.destroyElement();
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  beforeUnmount: function beforeUnmount() {},
  watch: {
    modelValue: function modelValue(newValue) {
      this.visible = newValue;
    },
    visible: function visible(newValue) {
      this.$emit('update:modelValue', newValue);
    }
  }
};